/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, TablePagination, TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Checkbox, CircularProgress, IconButton } from '@material-ui/core';
import {
    Link
} from "react-router-dom";

/**
 * region for redux*/
import { connect } from 'react-redux';
import { MiniSitesActions } from '../../actions/MiniSitesActions';

/**
 * region for styles*/
import { listMiniSiteStyle } from './style/listMiniSiteStyle';

/**
 * region for componets*/
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

/**
 * region for hepers*/

/**
 * region for constans*/


class ListMiniSite extends Component {

    state = {
        pageNumberMinisiteList: 1,
        pageSizeMinisiteList: 15
    };

    componentDidMount() {
        const { pageNumberMinisiteList, pageSizeMinisiteList } = this.state;
        let dataRequest = {
            pageNumberMinisiteList: pageNumberMinisiteList,
            pageSizeMinisiteList: pageSizeMinisiteList
        };
        this.setState({ pageNumberMinisiteList: pageNumberMinisiteList, pageSizeMinisiteList: pageSizeMinisiteList });
        this.props.fetchMiniSiteGetListMiniSites(dataRequest);
    }

    onChangePage = (e, newPage) => {
        const { pageSizeMinisiteList } = this.state;
        newPage = newPage + 1;
        let dataRequest = {
            pageNumberMinisiteList: newPage,
            pageSizeMinisiteList: pageSizeMinisiteList
        };
        this.setState({ pageNumberMinisiteList: newPage, pageSizeMinisiteList: pageSizeMinisiteList });
        this.props.fetchMiniSiteGetListMiniSites(dataRequest);
    };

    render() {
        const { classes } = this.props;
        const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

        let countRows = -1;
        let rows;
        if (Object.keys(this.props.selectListMinisite).length > 0) {
            countRows = this.props.selectListMinisite.totalCount;
            rows = this.props.selectListMinisite.data.map((item, index) =>
                <TableRow key={index} hover>
                    <TableCell align="center" padding="checkbox">
                        <Checkbox
                            value={item.IDMINISITE}
                            with={25}
                        />
                    </TableCell>
                    <TableCell align="left">{item.NAME}</TableCell>
                    <TableCell align="left">{item.DOMAIN_NAME}</TableCell>
                    <TableCell align="center" with={10} padding="checkbox">
                        <Link to={"/LayoutMiniSite/Update/" + item.IDMINISITE} >
                            <IconButton with={10}>
                                <EditOutlinedIcon />
                            </IconButton>
                        </Link>
                    </TableCell>
                </TableRow>
            );
        }
        return (
            <Grid
                className={classes.contentAll}
                container
                spacing={0} >
                <Grid item xs={12} md={12} lg={12}>
                    {
                        <Paper className={fixedHeightPaper}>
                            <Grid container spacing={0}>
                                <Grid container item xs={12} spacing={0}>
                                    <div className={classes.root}>
                                        <Fragment>
                                            <TableContainer>
                                                <Table
                                                    aria-labelledby="tableTitle"
                                                    size='small'
                                                    aria-label="enhanced table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" padding="checkbox"></TableCell>
                                                            <TableCell align="left">NAME</TableCell>
                                                            <TableCell align="left">URL</TableCell>
                                                            <TableCell align="center"></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            (this.props.pending === true) && <TableRow><TableCell align="center" colSpan={5}><CircularProgress size={24} /></TableCell></TableRow>
                                                        }
                                                        {
                                                            (this.props.pending === false && countRows > 0) && rows
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            {
                                                (countRows > 0) && <TablePagination
                                                    rowsPerPageOptions={[10]}
                                                    count={countRows}
                                                    rowsPerPage={this.state.pageSizeMinisiteList}
                                                    page={this.state.pageNumberMinisiteList - 1}
                                                    component="div"
                                                    onChangePage={this.onChangePage}
                                                />
                                            }
                                        </Fragment>

                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                    }
                </Grid>
            </Grid >
        );
    }
}
ListMiniSite.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const selectListMinisite = state.MiniSitesReducers.selectListMinisite;
    const pending = state.MiniSitesReducers.pending;
    return {
        selectListMinisite,
        pending
    };
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMiniSiteGetListMiniSites: (dataRequest) => dispatch(MiniSitesActions.fetchMiniSiteGetListMiniSites(dataRequest))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(listMiniSiteStyle)(ListMiniSite));